import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=e5e38b36&scoped=true"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInfo.vue?vue&type=style&index=0&id=e5e38b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e38b36",
  null
  
)

export default component.exports